import { API_BASE_URL } from '../../../../api';
import React, { useContext, useState } from "react";
import { AccountContext } from '../../../../Contexts/main.context';

const CitationUploader = () => {
     const context = useContext(AccountContext);
     const { activeClient } = context || {};
     const [uploadMessage, setUploadMessage] = useState("");
     const [formData, setFormData] = useState({
          username: "",
          email: "",
          emailPassword: "",
          directoryPass: "",
          emailLocation: "",
          condensedFormat: false,
          uploadMonth: "",
          uploadYear: "",
     });

     const [file, setFile] = useState(null);

     const handleInputChange = (e) => {
          const { name, value, type, checked } = e.target;
          setFormData((prev) => ({
               ...prev,
               [name]: type === "checkbox" ? checked : value,
          }));
     };

     const handleFileChange = (e) => {
          setFile(e.target.files[0]);
     };

     const handleSubmit = async (e) => {
          e.preventDefault();
          console.log(formData);
          if (!file) return alert("Please select a CSV file.");

          const formPayload = new FormData();
          formPayload.append("citationFile", file);
          formPayload.append("clientID", activeClient?.ID || 0);

          Object.entries(formData).forEach(([key, value]) => {
               formPayload.append(key, value);
          });

          setUploadMessage("Uploading...");

          try {
               const response = await fetch(API_BASE_URL + 'upload_citation.php', {
                    method: "POST",
                    body: formPayload,
               });

               const result = await response.text();
               setUploadMessage(result);
          } catch (err) {
               console.error(err);
               setUploadMessage("Upload failed. Please try again.");
          }
     };

     return (
          <div className="col-46 offset-1">
               <div className="justify-content-center p-4 fs-5 fw-bold mb-2 d-flex">
                    <div>
                         Current Location - {activeClient.companyName} - [{activeClient.theLocation}]
                    </div>
               </div>
               <div className="alert bg-navy text-white p-3 rounded">
                    <strong>Instructions:</strong> Please upload a <span className="text-lemon">.csv</span> file information:
                    <ul className="mt-2 mb-0">
                         <li><strong>1</strong> → Go to BrightLocal.com - Choose Citation Tracker - Then Export either Live Citations / Citations using Action Button</li>
                         <li><strong>2</strong> → Download the File as a CSV</li>
                         <li><strong>3</strong> → You need to get the Login Credentials (Citation Builder) Citation Login Credentials</li>
                         <li><strong>4</strong> → If Importing BrightLocal csv, you need to put the Login Credentials in the Form before uploading</li>
                         <li><strong>5</strong> → IF YOU ARE UPLOADING Citations from the Monday Excel Files, Choose Condensed Format Checkbox</li>
                         <li><strong>6</strong> → Press on the Upload Button</li>
                    </ul>
                    <div className="fw-bold text-lemon mt-3 text-center">
                         This will upload your Data and make it visible in the Client Facing Portal. To View your Citations and Check them for accuracy, You will be returned to View Citations after your upload completes
                    </div>
               </div>

               <form onSubmit={handleSubmit} className="border p-4 rounded shadow-sm bg-light">
                    <div className="mb-3">
                         <label htmlFor="citationFile" className="form-label fw-bold">
                              Select Citation CSV File:
                         </label>

                         {/* Condensed Format Toggle */}
                         <div className="d-flex align-items-center gap-3 mb-3">
                              <div className="form-check d-flex align-items-center m-0 gap-2">
                                   <input
                                        type="checkbox"
                                        id="condensedCheck"
                                        name="condensedFormat"
                                        className="form-check-input"
                                        style={{ width: "24px", height: "24px", cursor: "pointer" }}
                                        checked={formData.condensedFormat}
                                        onChange={handleInputChange}
                                   />
                                   <label htmlFor="condensedCheck" className="form-check-label fw-bold">
                                        Condensed Format
                                   </label>
                              </div>
                         </div>

                         {/* Month and Year Dropdowns */}
                         {formData.condensedFormat && (
                              <div className="alert-success p-3">
                                   <div className="d-flex gap-2 mb-2">
                                        <div className="col-24">
                                             <label className="form-label">Upload Month</label>
                                             <select
                                                  name="uploadMonth"
                                                  className="form-control"
                                                  value={formData.uploadMonth}
                                                  onChange={handleInputChange}
                                                  required
                                             >
                                                  <option value="">Select Month</option>
                                                  {[
                                                       "January", "February", "March", "April", "May", "June",
                                                       "July", "August", "September", "October", "November", "December"
                                                  ].map((month, idx) => (
                                                       <option key={idx + 1} value={idx + 1}>
                                                            {month}
                                                       </option>
                                                  ))}
                                             </select>
                                        </div>

                                        <div className="flex-grow-1">
                                             <label className="form-label">Upload Year</label>
                                             <select
                                                  name="uploadYear"
                                                  className="form-control"
                                                  value={formData.uploadYear}
                                                  onChange={handleInputChange}
                                                  required
                                             >
                                                  <option value="">Select Year</option>
                                                  {Array.from({ length: 10 }, (_, i) => {
                                                       const year = new Date().getFullYear() - i;
                                                       return (
                                                            <option key={year} value={year}>
                                                                 {year}
                                                            </option>
                                                       );
                                                  })}
                                             </select>
                                        </div>
                                   </div>
                              </div>
                         )}

                         {/* CSV File Input */}
                         <div className="col-48">
                              <input
                                   type="file"
                                   name="citationFile"
                                   id="citationFile"
                                   accept=".csv"
                                   className="form-control"
                                   onChange={handleFileChange}
                                   required
                              />
                         </div>
                    </div>

                    {/* BrightLocal Fields */}
                    {!formData.condensedFormat && (
                         <div className="card shadow-sm p-4 mt-4">
                              <h5 className="mb-4 text-primary text-center">
                                   Bright Local Citation Information - Please enter login details.
                              </h5>

                              <div className="row">
                                   <div className="col-24 mb-3">
                                        <label className="form-label">Username</label>
                                        <input
                                             type="text"
                                             name="username"
                                             value={formData.username}
                                             onChange={handleInputChange}
                                             className="form-control"
                                        />
                                   </div>

                                   <div className="col-24 mb-3">
                                        <label className="form-label">Email</label>
                                        <input
                                             type="text"
                                             name="email"
                                             value={formData.email}
                                             onChange={handleInputChange}
                                             className="form-control"
                                        />
                                   </div>

                                   <div className="col-24 mb-3">
                                        <label className="form-label">Email Password</label>
                                        <input
                                             type="text"
                                             name="emailPassword"
                                             value={formData.emailPassword}
                                             onChange={handleInputChange}
                                             className="form-control"
                                        />
                                   </div>

                                   <div className="col-24 mb-3">
                                        <label className="form-label">Directory Password</label>
                                        <input
                                             type="text"
                                             name="directoryPass"
                                             value={formData.directoryPass}
                                             onChange={handleInputChange}
                                             className="form-control"
                                        />
                                   </div>

                                   <div className="col-48 mb-3">
                                        <label className="form-label">Email Link</label>
                                        <input
                                             type="text"
                                             name="emailLocation"
                                             value={formData.emailLocation}
                                             onChange={handleInputChange}
                                             className="form-control"
                                        />
                                   </div>
                              </div>
                         </div>
                    )}

                    <div className="col-48 d-flex justify-content-center">
                         <button type="submit" className="btn btn-success text-light fw-bold px-5 mt-3">
                              Upload
                         </button>
                    </div>
               </form>


               {uploadMessage && (
                    <div className="alert alert-info mt-3">
                         {uploadMessage}
                    </div>
               )}
          </div>
     );
};

export default CitationUploader;
